:host {
  display: block;
  padding: $xp-ref-spacing-4 $xp-ref-spacing-4 $xp-ref-spacing-4 $xp-ref-spacing-3;
  gap: $xp-ref-spacing-4;
  overflow: hidden;
}

.content {
  display: flex;
  flex-direction: row;
  gap: 12px;
  color: $xp-ref-color-semantic-on-info;

  .material-icons {
    font-size: $xp-ref-spacing-6;
    &.top-right {
      cursor: pointer;
    }
  }

  .text {
    display: flex;
    flex-direction: column;
    gap: $xp-ref-spacing-2;
    font: $xp-ref-font-label-label-long;
    overflow-wrap: anywhere;
    .button {
      width: max-content;
      height: $xp-ref-size-7;
      border: 2px solid;
      background-color: inherit;
    }
  }
}
